export default __webpack_public_path__ + "static/media/3.93c41d6b.jpg";